



















import { Component, Vue } from 'vue-property-decorator'
import nameAndDepart from './nameAndDepart.vue'
import teacherStudentStno from './teacherStudentStno.vue'
import schoolModify from './schoolModify.vue'
import addTeachLesson from './addTeachLesson.vue'
import majorModify from './majorModify.vue'
import interSchoolTime from './interSchoolTime.vue'
import gradeModify from './gradeModify.vue'

@Component({
  components: {
    teacherStudentStno,
    nameAndDepart,
    schoolModify,
    addTeachLesson,
    majorModify,
    interSchoolTime,
    gradeModify,
  },
})
export default class AllInfoModify extends Vue {
  private modify: string | any = ''
  mounted() {
    this.modify = this.$route.query.modify
  }
}
